"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNewGoogleAccount = exports.updateGoogleAccount = exports.importGoogleDoc = exports.fetchGoogleAccounts = exports.fetchGoogleAccessToken = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _convertGoogleToHTML = require("composer-lib/lib/convertGoogleToHTML");

var _draftJs = require("draft-js");

var _GoogleDocManager = _interopRequireDefault(require("composer-lib/data/GoogleDocManager"));

var _uiSettings = require("./uiSettings");

var _composer = require("./composer");

var googleDocManager = new _GoogleDocManager.default();
var fetchGoogleAccessTokenPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_PENDING);
var fetchGoogleAccessTokenSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_SUCCEEDED);
var fetchGoogleAccessTokenFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_FAILED);

var fetchGoogleAccessToken = function fetchGoogleAccessToken() {
  return function (dispatch) {
    dispatch(fetchGoogleAccessTokenPending());
    googleDocManager.getDefaultAuthInfo().then(function (resp) {
      return dispatch(fetchGoogleAccessTokenSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchGoogleAccessTokenFailed(resp));
    });
  };
};

exports.fetchGoogleAccessToken = fetchGoogleAccessToken;
var fetchGoogleAccountsPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_PENDING);
var fetchGoogleAccountsSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_SUCCEEDED);
var fetchGoogleAccountsFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_FAILED);

var fetchGoogleAccounts = function fetchGoogleAccounts() {
  return function (dispatch) {
    dispatch(fetchGoogleAccountsPending());
    googleDocManager.getAllAccounts().then(function (resp) {
      return dispatch(fetchGoogleAccountsSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchGoogleAccountsFailed(resp));
    });
  };
};

exports.fetchGoogleAccounts = fetchGoogleAccounts;
var importGoogleDocPending = (0, _utils.createAction)(_ActionTypes.default.IMPORT_GOOGLE_DOC_PENDING);
var importGoogleDocSucceeded = (0, _utils.createAction)(_ActionTypes.default.IMPORT_GOOGLE_DOC_SUCCEEDED);
var importGoogleDocFailed = (0, _utils.createAction)(_ActionTypes.default.IMPORT_GOOGLE_DOC_FAILED);
var importGoogleDocImageUploadFailed = (0, _utils.createAction)(_ActionTypes.default.IMPORT_GOOGLE_DOC_IMAGE_UPLOAD_FAILED);

var importGoogleDoc = function importGoogleDoc(fileId, compositionId, email, addToast, composerSettings) {
  return function (dispatch) {
    dispatch(importGoogleDocPending());
    googleDocManager.importGoogleDocToComposition(fileId, compositionId, email).then(function (resp) {
      dispatch(importGoogleDocSucceeded());
      var allUploadsSucceeded = resp.allUploadsSucceeded,
          composition = resp.composition;

      var newEditorState = _draftJs.EditorState.createWithContent( // TODO: make this async conversion and reflect loading in UI?
      (0, _editorConfigs.convertFromHTML)(composerSettings, {
        props: {
          addToast: addToast
        }
      })((0, _convertGoogleToHTML.convertGoogleDocToHTML)(composition.htmlBody)));

      (0, _composer.updateTitleToSave)(composition.title)(dispatch);
      (0, _composer.updateContentToSave)(newEditorState)(dispatch);

      if (allUploadsSucceeded === false) {
        dispatch(importGoogleDocImageUploadFailed());
      }
    }, function (resp) {
      return dispatch(importGoogleDocFailed(resp));
    });
  };
};

exports.importGoogleDoc = importGoogleDoc;
var caUpdateGoogleAccount = (0, _utils.createAction)(_ActionTypes.default.UPDATE_GOOGLE_ACCOUNT);

var updateGoogleAccount = function updateGoogleAccount(data) {
  return function (dispatch) {
    return googleDocManager.getValidAuthInfo(data.email).then(function (resp) {
      return dispatch(caUpdateGoogleAccount(resp));
    }, function () {
      dispatch((0, _uiSettings.hideGoogleDocsPicker)());
      dispatch((0, _uiSettings.showGoogleAuthError)());
    });
  };
};

exports.updateGoogleAccount = updateGoogleAccount;

var updateNewGoogleAccount = function updateNewGoogleAccount(email) {
  return function (dispatch) {
    return googleDocManager.getValidAuthInfo(email).then(function (resp) {
      dispatch(caUpdateGoogleAccount(resp));
      dispatch((0, _uiSettings.dismissGoogleAuthError)());
      dispatch((0, _uiSettings.showGoogleDocsPicker)());
    }, function () {
      return dispatch((0, _uiSettings.showGoogleAuthError)());
    });
  };
};

exports.updateNewGoogleAccount = updateNewGoogleAccount;